import { useState } from "react";
import { Plus } from "lucide-react";
import {
  StyledInput,
  StyledInputContainer,
  StyledInputGroup,
  StyledLabel,
} from "../../StyledCss/styledInputs";
import { PrimaryButton } from "../../StyledCss/styledbtn";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const MultiInput = ({
  placeholder = "Enter value",
  label = "Label",
  existingItems = [],
  newItems = [],
  onAdd,
  onRemove,
  existingItemKey = "name",
  email = false,
}) => {
  const [currentValue, setCurrentValue] = useState("");
  const [error, setError] = useState("");

  const handleAdd = (e) => {
    e.preventDefault();
    const val = currentValue.trim();
    if (!val) return;
    if (email && !EMAIL_REGEX.test(val)) {
      setError("Enter a valid email address");
      return;
    }
    if (!newItems.includes(val)) {
      onAdd(val);
      setCurrentValue("");
      setError("");
    }
    else {
     setError("Item already exists");
     }
  };

  return (
    <div style={{ gridColumn: "1 / -1"}}>
      <div style={{ display: "flex", gap: "10px", width: "fit-content" }}>
        <StyledInputGroup style={{ flex: 1, margin: 0 }}>
          <StyledInputContainer>
            <StyledInput
              placeholder={placeholder}
              type="text"
              value={currentValue}
              onChange={(e) => { setCurrentValue(e.target.value); setError(""); }}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleAdd(e);
                }
              }}
            />
            <StyledLabel className="user-label">{label}</StyledLabel>
          </StyledInputContainer>
          {error && <span style={{ color: "red", fontSize: "11px", paddingLeft: "4px" }}>{error}</span>}
        </StyledInputGroup>

        <PrimaryButton
          onClick={handleAdd}
          style={{ marginTop: "0", flexShrink: 0, width: 40 }}
        >
          <Plus size={19} />
        </PrimaryButton>
      </div>

      {(existingItems.length > 0 || newItems.length > 0) && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            marginTop: "10px",
          }}
        >
          {existingItems.map((item) => (
            <span
              key={`existing-${item.id}`}
              style={{
                fontSize: "12px",
                padding: "4px 10px",
                backgroundColor: "#e3f2fd",
                color: "#1976d2",
                borderRadius: "12px",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              {item[existingItemKey]}
              <button
                type="button"
                onClick={() => onRemove(item, false)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#1976d2",
                  cursor: "pointer",
                  padding: "0",
                  fontSize: "16px",
                  lineHeight: "1",
                  fontWeight: "bold",
                }}
                title="Remove"
              >
                ×
              </button>
            </span>
          ))}
          {newItems.map((item, index) => (
            <span
              key={`new-${index}`}
              style={{
                fontSize: "12px",
                padding: "4px 10px",
                backgroundColor: "#e8f5e8",
                color: "#2e7d32",
                borderRadius: "12px",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              {item}
              <button
                type="button"
                onClick={() => onRemove(item, true)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#2e7d32",
                  cursor: "pointer",
                  padding: "0",
                  fontSize: "16px",
                  lineHeight: "1",
                  fontWeight: "bold",
                }}
                title="Remove"
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiInput;
